import '@/assets/less/TableExpand.less';
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
import EventPay from "../modal/EventPay";
import RefundModal from "../modal/RefundModal";
export default {
  name: "Order",
  components: {
    EventPay: EventPay,
    RefundModal: RefundModal
  },
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      columns: [{
        title: "#",
        dataIndex: "",
        key: "rowIndex",
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '订单编号',
        align: "center",
        dataIndex: 'orderNo'
      }, {
        title: '订单金额',
        align: "center",
        dataIndex: 'orderPrice',
        customRender: function customRender(value) {
          return value / 100;
        }
      }, {
        title: '支付金额',
        align: "center",
        dataIndex: 'payPrice',
        customRender: function customRender(value) {
          return value / 100;
        }
      }, {
        title: "状态",
        align: "center",
        width: 70,
        dataIndex: "orderStatus",
        customRender: function customRender(v) {
          switch (v) {
            case 0:
              return "未支付";
            case 1:
              return "已支付";
            case -1:
              return "已全额退款";
            case -2:
              return "超时";
            case -3:
              return "确认中";
            case -4:
              return "退款申请办理中";
          }
        }
      }, {
        title: '创建日期',
        align: "center",
        dataIndex: 'createTime'
      }, {
        title: "操作",
        dataIndex: "action",
        fixed: "right",
        align: "center",
        width: 100,
        scopedSlots: {
          customRender: "action"
        }
      }],
      url: {
        list: "/teaching/teachingOrder/mineEventOrder"
      },
      disableMixinCreated: true,
      //禁用mixin的created方法
      unitInfo: {}
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    search: function search() {
      this.loading = true;
      this.loadData(1);
    },
    toPay: function toPay(record) {
      this.$refs.eventPay.open(record);
    },
    refund: function refund(r) {
      this.$refs.refundModal.refund(r);
    },
    //通过自动化订单
    syncCAC: function syncCAC(record) {
      var _this = this;
      getAction("/teaching/teachingOrder/checkOrderCAC?outTradeNo=" + record.orderNo).then(function (res) {
        _this.$message.success(res.message);
        _this.searchQuery();
      });
    }
  }
};